import React, { useState } from "react";

import { Box } from "@chakra-ui/react";
import { closeIndividualSavings } from "api/individual-user-management";
import { ReactComponent as InfoOutlineIcon } from "assets/icons/info-outline.svg";
import { useIndividuals } from "contexts/individuals-context";
import { transactionLimitModalHeaderCss } from "features/individuals/individual-details/styles";

import { Button } from "ui/button";
import { customErrorToast, customSuccessToast } from "ui/custom-toast";
import { Modal } from "ui/modal";
import { ModalHeader } from "ui/modal/modal-header";
import { defaultModalCss } from "ui/modal/styles";
import { DEFAULT_PAGINATION_DATA } from "ui/pagination";
import { Heading3, Paragraph3 } from "ui/typography";

// import { transactionLimitModalHeaderCss } from "../styles";
import { ICloseSavingsModalProps } from "./types";

export const CloseSavingsModal = (props: ICloseSavingsModalProps) => {
  const {
    isOpen,
    setIsOpen,
    handleToggleCloseSavingsModal,
    id,
    type,
    walletId,
  } = props;

  const [isClosing, setIsClosing] = useState(false);

  const { handleGetIndividualSavings } = useIndividuals();

  const handleCloseSavings = async () => {
    // if (!individualDetails) return;
    setIsClosing(true);
    try {
      const { error, message } = await closeIndividualSavings({
        id: id || "",
        plan: type || "flex",
      });
      if (error) {
        customErrorToast({
          message,
        });
        // setIsOpen(false);
        handleToggleCloseSavingsModal();
      } else {
        customSuccessToast({
          message: "Savings Closed Successfully",
        });
        await handleGetIndividualSavings({
          walletId: +walletId,
          page: DEFAULT_PAGINATION_DATA.page,
          limit: DEFAULT_PAGINATION_DATA.page,
        });
        handleToggleCloseSavingsModal();
        // setIsOpen(false);
      }
    } catch (error) {
      console.error("Error: ", error);
      // setIsOpen(false);
      handleToggleCloseSavingsModal();
    }
    setIsClosing(false);
  };

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      modalCss={{
        ...defaultModalCss,
        width: "400px",
        // height: "304px",
        padding: "24px",
        gap: "32px",
      }}
      allowOutsideClick={false}
    >
      <Box className="flex flex-col gap-5">
        <ModalHeader
          modalType="rejection"
          modalHeaderCss={transactionLimitModalHeaderCss}
        />
        <Box className="flex flex-col gap-2">
          <Heading3
            fontSize="18px"
            lineHeight="28px"
            textColor="#101828"
            fontWeight="600"
          >
            {type === "goal"
              ? "Close This Goal Savings"
              : "Close This Flex Savings"}
          </Heading3>
          <Paragraph3
            lineHeight="20px"
            textColor="#475467"
          >
            Please confirm that you want to perform this action.
          </Paragraph3>
          {type === "goal" && (
            <Box className="bg-[#FEF5E7] border border-[#FFEFD8] rounded-2xl p-3 flex items-center gap-[8px]">
              <InfoOutlineIcon className="flex-shrink-0" />
              <Paragraph3
                lineHeight="20px"
                textColor=" #1A202C"
              >
                Closing this savings will return the saved amount to the
                customer's account and they will lose their accrued interest.
              </Paragraph3>
            </Box>
          )}
        </Box>
      </Box>
      <Box
        css={{
          //   height: "44px",
          display: "flex",
          alignItems: "center",
          gap: "12px",
        }}
      >
        <Button
          variant="outline"
          textColor="#344054"
          border="1px solid #D0D5DD"
          className="w-[170px]"
          onClick={handleToggleCloseSavingsModal}
          disabled={isClosing}
        >
          Cancel
        </Button>
        <Button
          variant="solid"
          textColor="#ffffff"
          border="1px solid #00535C"
          className="w-[170px]"
          onClick={handleCloseSavings}
          disabled={isClosing}
          loading={isClosing}
          loadingText="Closing..."
        >
          Confirm
        </Button>
      </Box>
    </Modal>
  );
};
